import * as React from "react";
import Header from "@appComponents/Header/Header";
import { Layout, Tabs, Tooltip } from "antd";

import Funds from "./tabs/Funds/Funds";
import { classNames } from "@features/utils/reactFunctions";

import * as style from "./FundsAppStyle.module.scss"

const FundsApp = (props: any) => {

  const urlHasParticularAction = [
    "withdraw",
    "deposit",
    "buy",
    "sell",
  ].includes(props.match?.params?.action);

  const urlHasParticularSubpage = ["deposit-with-bank-transfer"].includes(
    props.match?.params?.subpage
  );
  const hideMainTabs = urlHasParticularAction || urlHasParticularSubpage;

  const tabStyles = hideMainTabs ? style.hideTabs : null;

  const tabs = [
    {
      label: "My Funds",
      key: "1",
      children: <Funds />,
    },
    {
      label: <Tooltip title="Coming soon">Auto-Invest</Tooltip>,
      key: "2",
      disabled: true,
    },
  ];

  return (
    <>
      <Header padding="140 20" />
      <div className={classNames(style.wrapper, tabStyles)}>
        <div className={style.layout}>
          <Layout className={style.layout}>
            <Layout.Content>
              <Tabs
                centered
                defaultActiveKey="1"
                items={tabs}
                className={style.tabs}
              />
            </Layout.Content>
          </Layout>
        </div>
      </div>
    </>
  );
};

export default FundsApp;
